export const generateToggledFunction = (fn, disabled) => {
    return !disabled ? fn : null
}